import React, { useEffect, useState } from 'react';
import { message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import UsersTable from '../../components/usersTable/UsersTable';
import { fetchUsers } from '../../redux/users/actionCreator';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api';

const Users = () => {
  const { loading } = useSelector(state => state.users);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [state, setState] = useState({ loadingScreen: false });

  useEffect(() => {
    dispatch(fetchUsers({ page: pageNumber }));
  }, [pageNumber, dispatch]);

  const handleOnChangePageNumber = number => {
    setPageNumber(number);
  };

  const handleOnDeleteUser = async idToRemove => {
    setState({
      ...state,
      loading: true,
    });

    DataService.delete(`${API.pos.users}/${idToRemove}`)
      .then(_data => {
        message.success('Usuario Eliminado');
        setState({ ...state, loading: false });
        dispatch(fetchUsers({ page: pageNumber }));
      })
      .catch(_err => {
        setState({ ...state, loading: false });
      });
  };

  return (
    <>
      {loading ? (
        <Spin size="large" />
      ) : (
        <UsersTable
          pageNumber={pageNumber}
          onChangePageNumber={handleOnChangePageNumber}
          onDeleteUser={handleOnDeleteUser}
        />
      )}
    </>
  );
};

export default Users;
